import { Fragment } from "react";
import { CompanyScheduler } from "../../containers/CompanyCalendar/CompanyScheduler";

function CompanyCalendar() {
  return (
    <Fragment>
      <CompanyScheduler></CompanyScheduler>
    </Fragment>
  );
}

export { CompanyCalendar };
